import React, { useState } from "react";
import "./Header.css";
import { Link, useLocation } from "react-router-dom";
import { Nav, Navbar } from "react-bootstrap";
import Common_download_btn from "../common/common-download-btn/Common_download_btn";

function Header() {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <section className='Header_holder'>
        <Navbar expand="lg" className="Header" expanded={expanded}>
          <div className="container">
            <Navbar.Brand as={Link} to="/" onClick={() => setExpanded(false)}>
              <div className="logo_holder">
                <img
                  className="logo_img"
                  src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
                  alt="ayansh logo"
                />
              </div>
            </Navbar.Brand>

            <div className="d-block d-lg-none">
              <Common_download_btn />
            </div>

            <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setExpanded(!expanded)} />

            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mx-auto">
                <Nav.Link
                  as={Link}
                  to="/"
                  onClick={() => setExpanded(false)}
                  className={location.pathname === "/" ? "active" : ""}
                >
                  Home
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/about-us"
                  onClick={() => setExpanded(false)}
                  className={location.pathname === "/about-us" ? "active" : ""}
                >
                  About Us
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/services"
                  onClick={() => setExpanded(false)}
                  className={location.pathname === "/services" ? "active" : ""}
                >
                  Services
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/contact-us"
                  onClick={() => setExpanded(false)}
                  className={location.pathname === "/contact-us" ? "active" : ""}
                >
                  Contact Us
                </Nav.Link>
              </Nav>

              <div className="d-none d-lg-block">
                <Common_download_btn />
              </div>

            </Navbar.Collapse>
          </div>
        </Navbar>
      </section>
    </>
  );
}

export default Header;
